import { Moment } from "moment";
import Utils from "../../core/shared/utils";
import { SyncModel, SyncDataModel, DataModel } from "../../core/shared/models/syncModel";
import { ContentType, ImageOrientation } from "../../core/shared/contentTypes";

// ViewModel
export class SOTAdvertisementViewModel {
  public get has_image(): boolean {
    return this._model.last_image_update_at_ymd > 0
  }
  public get image_path(): string {
    if (this.has_image)
      return ContentType.SOTAdvertisement + "/" + this._model.id + "_photo_" + ImageOrientation.Landscape + "/" + this._model.last_image_update_at_ymd + "/" + this._model.last_image_update_at_hms;
    else
      return "";
  }

  public get item_group_id(): number {
    return this._model.item_group_id;
  }

  private _model: SOTAdvertisementDataModel;
  public get model(): SOTAdvertisementDataModel {
    return this._model;
  }

  constructor(model: SOTAdvertisementDataModel) {
    const me = this;
    me._model = model;
  }
}

// Requests
export class SOTAdvertisementSyncModel extends SyncModel {
  public hyp_cus_nr: number;
}

// Responses
export class SOTAdvertisementDataModel extends DataModel {
  public get DM_Key(): number | string { return this.id; }
  public id: number;
  public label: string;
  public active: boolean;
  public sort_no: number;
  public use_in_house_service: boolean;
  public use_pickup_service: boolean;
  public languages: string[];
  public item_group_id: number;
  public last_image_update_at_ymd: number;
  public last_image_update_at_hms: number;
  public get last_image_update_at(): Moment {
    return Utils.GetMomentFromInt(this.last_image_update_at_ymd, this.last_image_update_at_hms);
  }
  public use_limitation: boolean;
  public limitation_days: number;
  public limitation_start_hms: number;
  public limitation_end_hms: number;
  public deleted: boolean;
  public change_at_ymd: number;
  public change_at_hms: number;
  public get change_at(): Moment {
    return Utils.GetMomentFromInt(this.change_at_ymd, this.change_at_hms);
  }
}

export class SOTAdvertisementSyncDataModel extends SyncDataModel {
  public advertisements: SOTAdvertisementDataModel[];
  public get models(): DataModel[] { return this.advertisements; }
  public DeserializeType(): void {
    this._DeserializeType(SOTAdvertisementDataModel);
  }
}
